import { instance } from "apis/interceptor";
import { TCalendarVisit } from "./type";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

//INFO: 개인 캘린더에 방문 일정 추가
export const addPersonalCalendar = async (calendar: TCalendarVisit): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.post("/visitors/personal-calendar", calendar);
    return { success: res.data.result };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//INFO: 개인 캘린더에 방문 일정 수정
export const updatePersonalCalendar = async (calendar: TCalendarVisit): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/visitors/personal-calendar", calendar);
    return { success: res.data.result };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//INFO: 개인 캘린더 감지 여부 조회하기
export const getDetectionPernalCalendarSetting = async (): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.get("/visitors/personal-calendar/detection");
    return { success: true, data: res.data.isPersonalCalendarDetected };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//INFO: 개인 캘린더 감지 해제하기
export const unlinkDetectionPersonalCalendar = async (): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.delete("/visitors/personal-calendar/detection");
    return { success: res.data.result };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//INFO: 개인 캘린더 감지 설정하기
export const linkDetectionPersonalCalendar = async (): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/visitors/personal-calendar/detection");
    return { success: res.data.result };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};
